<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex sx12>
          <h1 class="mt-n2 mb-4">{{ ct.TitleText }}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          <v-card v-else raised>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-layout justify-end>
                  <div>
                    <v-checkbox :label="ct.Active" v-model="form.active" :color="'primary'"></v-checkbox>
                  </div>
                </v-layout>

                <v-select v-if="isAdmin()"
                v-model="form.corporation"
                :items="corporations"
                :label="ct.Corporation"
                :rules="[rules.required]"
                :no-data-text="ct.NoDataAvailable" />
                <v-text-field v-model="form.no" :disabled="isEditing()" :label="ct.No" :rules="[rules.required]" />
                <v-text-field v-model="form.description" :label="ct.Description" />

                <v-card class="mt-4" v-if="hasStorageMapClaim" raised>
                  <v-card-text>
                    <v-form ref="form">
                      <v-layout justify-end></v-layout>
                      <h3 class="mb-4">{{$t('Storage Map')}} : {{$t('Settings')}}</h3>
                      <v-flex xs12>
                        <v-input
                          :rules="[true]"
                          required="true"
                          :value="item.FileItems">
                          <v-layout row wrap>
                            <v-flex d-flex>{{$t("Map Image")}}</v-flex>
                          </v-layout>
                        </v-input>
                        <input type="file" ref="image" name="image" accept="image/*" capture="environment" @change="onFilePicked">
                      </v-flex>
                        <v-flex xs6 sm6 md3 lg2 v-for="(image, index) in item.FileItems" :key="index">
                          <div id="im" class="image_container">
                            <img :src="image.ImageData" class="zoom">
                            <div class="after faded">
                            <p class="black--text full text-left">
                              <v-btn icon color="warning" @click="removeFile(index)">
                                <v-icon>cancel</v-icon>
                              </v-btn>
                            </p>
                            </div>
                            <v-checkbox v-model="form.newRegBtn" :label="$t('Show New Registration')" :color="'primary'"></v-checkbox>
                            <v-checkbox v-model="form.newRegUpBtn" :label="$t('Show New Registration (count up)')" :color="'primary'"></v-checkbox>
                            <v-checkbox v-model="form.newRegDownBtn" :label="$t('Show New Registration (count down)')" :color="'primary'"></v-checkbox>
                          </div>
                        </v-flex>
                    </v-form>
                  </v-card-text>
                </v-card>

                <v-card class="mt-4" v-if="hasPreRegistrationClaim" raised>
                  <v-card-text>
                    <v-form ref="form">
                      <v-layout justify-end></v-layout>
                      <h3 class="mb-4">{{$t('Pre-registration')}} : {{$t('Settings')}}</h3>
                      <v-flex xs12>
                        <v-text-field v-model="form.preRegistrationGPSPosition" :label="$t('GPS Position (latitude, longitude)')" :rules="[rules.gpsPosition]">
                          <template v-slot:append>
                            <v-btn class="mb-1" color="success" :href="'https://www.google.com/maps/place/' + form.preRegistrationGPSPosition" target="_blank"><v-icon>place</v-icon></v-btn>
                          </template>
                        </v-text-field>
                        <v-text-field v-model="form.preRegistrationGPSAcceptedDistanceKm" :label="$t('GPS Accepted Distance (Km)')" :rules="[(form.preRegistrationGPSAcceptedDistanceKm && form.preRegistrationGPSAcceptedDistanceKm >= 0 && form.preRegistrationGPSAcceptedDistanceKm <= 100) || this.$t('Invalid. Must be between 0-100 Km')]"></v-text-field>
                      </v-flex>
                    </v-form>
                  </v-card-text>
                </v-card>

                <v-card class="mt-4" v-if="hasScanMobileClaim" raised>
                  <v-card-text>
                    <v-form ref="form">
                      <v-layout justify-end></v-layout>
                      <h3 class="mb-4">{{$t('Scan Mobile')}} : {{$t('Settings')}}</h3>
                        <v-flex>
                          <v-layout row wrap>
                            <v-flex xs12 md4>
                              <v-checkbox v-model="form.localZplPrinter" :label="$t('Local ZPL secure print')" :color="'primary'"></v-checkbox>
                              <v-flex d-flex>{{$t("With local ZPL print a fixed registration slip is printed.")}}</v-flex>
                              <v-flex d-flex>{{$t("The slip is printed on the users local ZPL printer.")}}</v-flex>
                              <v-flex d-flex>{{$t("The local https ZPL printer must be connected to same WiFi as the ScanPortal browser.")}}</v-flex>
                            </v-flex>
                            <v-flex xs12 md4>
                              <v-checkbox v-model="form.localPrinter" :label="$t('Localprint')" :color="'primary'"></v-checkbox>
                              <v-flex d-flex>{{$t("With local print a fixed slip is printed and the user have to choose which printer it should be printed on.")}}</v-flex>
                              <v-flex d-flex>{{$t("The slip is printed on any of the printers known by the device.")}}</v-flex>
                              <v-flex d-flex>{{$t("")}}</v-flex>
                            </v-flex>
                            <v-flex xs12 md4>
                              <v-textarea
                                outlined
                                name="input-7-1"
                                label="Print title"
                                value="form.printTitle"
                                v-model="form.printTitle"
                                hint="">
                              </v-textarea>
                            </v-flex>
                        </v-layout>
                        </v-flex>
                    </v-form>
                  </v-card-text>
                </v-card>
                <v-card class="mt-4" v-if="hasWheelLoaderClaim" raised>
                  <v-card-text>
                    <v-form ref="form">
                      <v-layout justify-end></v-layout>
                      <h3 class="mb-4">{{$t('Wheel loader')}} : {{$t('Settings')}}</h3>
                        <v-flex>
                          <v-layout row wrap>
                            <v-flex xs12 md4>
                              <v-checkbox v-model="form.localZplPrinterWl" :label="$t('Local ZPL secure print')" :color="'primary'"></v-checkbox>
                              <v-flex d-flex>{{$t("With local ZPL print a fixed registration slip is printed.")}}</v-flex>
                              <v-flex d-flex>{{$t("The slip is printed on the users local ZPL printer.")}}</v-flex>
                              <v-flex d-flex>{{$t("The local https ZPL printer must be connected to same WiFi as the ScanPortal browser.")}}</v-flex>
                            </v-flex>
                            <v-flex xs12 md4>
                              <v-checkbox v-model="form.localPrinterWl" :label="$t('Localprint')" :color="'primary'"></v-checkbox>
                              <v-flex d-flex>{{$t("With local print a fixed slip is printed and the user have to choose which printer it should be printed on.")}}</v-flex>
                              <v-flex d-flex>{{$t("The slip is printed on any of the printers known by the device.")}}</v-flex>
                              <v-flex d-flex>{{$t("")}}</v-flex>
                            </v-flex>
                            <v-flex xs12 md4>
                              <v-textarea
                                outlined
                                name="input-7-1"
                                label="Print title"
                                value="form.printTitleWl"
                                v-model="form.printTitleWl"
                                hint="">
                              </v-textarea>
                            </v-flex>
                        </v-layout>
                        </v-flex>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :loading="submitting"
                :disabled="!valid"
                @click="submit"
                color="success" min-width="97px"
              >{{ct.SaveBtnText}} {{buttonAppend}}</v-btn>
              <v-btn color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as Admin from '@/core/admin'
import * as Security from '@/core/security'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as License from '@/core/license'
import { readAndCompressImage } from 'browser-image-resizer'
import mediumZoom from 'medium-zoom'

export default {
  mixins: [ct, rules, preventLeave],

  data: () => ({
    dataType: 'facility',
    loading: true,
    submitting: false,
    valid: true,
    redirectTo: 'facilities',
    hasStorageMapClaim: false,
    hasScanMobileClaim: false,
    hasPreRegistrationClaim: false,
    hasWheelLoaderClaim: false,
    item: {
      FileItems: []
    },
    acceptedFileTypes: ['png', 'jpg'],
    details: [],
    id: '00000000-0000-0000-0000-000000000000',
    form: {
      no: '',
      description: '',
      corporation: 0,
      active: true,
      storageMap: null,
      localPrinter: false,
      localZplPrinter: false,
      printTitle: '',
      preRegistrationGPSPosition: '',
      preRegistrationGPSAcceptedDistanceKm: null,
      localPrinterWl: false,
      localZplPrinterWl: false,
      printTitleWl: '',
      newRegUpBtn: false,
      newRegDownBtn: false,
      newRegBtn: true
    },
    corporations: []
  }),

  computed: {},

  methods: {
    isAdmin () {
      return Security.hasAccess([License.adminNo])
    },

    isEditing () {
      return this.id !== '00000000-0000-0000-0000-000000000000'
    },

    onPickFile () {
      this.$refs.image.click()
    },

    removeFile (index) {
      this.item.FileItems.splice(index, 1)
    },

    async onFilePicked (event) {
      this.item.FileItems = []
      const files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        const file = await readAndCompressImage(files[0], {
          quality: 0.7,
          maxWidth: 4000,
          maxHeight: 4000
        })

        const filename = files[0].name
        const regex = new RegExp(
          '.' + this.acceptedFileTypes.join('|') + '$',
          'i'
        )
        if (this.authentication) {
          if (filename && !filename.match(regex)) {
            this.$root.$message.showError(this.$t('File must be an image (jpg or png)'))
            event.target.value = ''
            return
          }
        }

        // calculate sum of all files sizes and validate max 10MB
        let sumSize = 0
        this.item.FileItems.forEach(item => { sumSize += item.ImageData.length })
        sumSize += file.size
        if (sumSize > 10000000) {
          this.$root.$message.showError(this.$t('Image size must be less than 10 Mb'))
          return
        }

        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.item.FileItems.push({ ImageData: fileReader.result, NameOfFile: filename })
          this.$nextTick(() => {
            mediumZoom(
              Array.from(document.querySelectorAll('.zoom')).filter(
                img => !img.classList.contains('medium-zoom-image')
              )
            )
          }, 0)
        })
        fileReader.readAsDataURL(file)
      } else {
        this.$store.dispatch('notify', {
          message: 'No file provided',
          color: 'error'
        })
        event.target.value = ''
      }
    },

    async submit () {
      this.preventLeave = false
      if (this.$refs.form.validate()) {
        this.submitting = true
        if (this.hasStorageMapClaim) {
          if (this.item.FileItems[0] !== undefined && this.item.FileItems[0].ImageData !== undefined) {
            this.details = []
            var base64Image = this.item.FileItems[0].ImageData.substr(this.item.FileItems[0].ImageData.indexOf(',') + 1)
            this.details.push({ Name: 'StorageMapImage', Data3AsBase64: base64Image })
          } else {
            this.details = []
          }
          this.details.push({ Name: 'newRegBtn', Value: this.form.newRegBtn.toString() })
          this.details.push({ Name: 'newRegUpBtn', Value: this.form.newRegUpBtn.toString() })
          this.details.push({ Name: 'newRegDownBtn', Value: this.form.newRegDownBtn.toString() })
        }
        if (this.hasScanMobileClaim) {
          this.details.push({ Name: 'localPrinter', Value: this.form.localPrinter.toString() })
          this.details.push({ Name: 'localZplPrinter', Value: this.form.localZplPrinter.toString() })
          this.details.push({ Name: 'printTitle', Value: this.form.printTitle.toString() })
        }
        if (this.hasWheelLoaderClaim) {
          this.details.push({ Name: 'localPrinterWl', Value: this.form.localPrinterWl.toString() })
          this.details.push({ Name: 'localZplPrinterWl', Value: this.form.localZplPrinterWl.toString() })
          this.details.push({ Name: 'printTitleWl', Value: this.form.printTitleWl.toString() })
        }
        if (this.hasPreRegistrationClaim) {
          this.details.push({ Name: 'PreRegistration_GPSPosition', Value: this.form.preRegistrationGPSPosition.toString() })
          this.details.push({ Name: 'PreRegistration_GPSAcceptedDistanceKm', Value: this.form.preRegistrationGPSAcceptedDistanceKm.toString() })
        }
        const res = await Admin.saveFacility({
          Id: this.id,
          No: this.form.no,
          CorporationId: this.form.corporation,
          Description: this.form.description,
          Active: this.form.active,
          Details: this.details
        })
        this.submitting = false
        if (!res.failed) {
          this.$root.$message.showSuccess(this.$t('Saved'))
          this.$router.push({ name: this.redirectTo })
        }
      }
    }
  },

  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    this.hasStorageMapClaim = Security.user.token.Claims.includes('69171060') // license.js: storageMapNo = '69171060'
    this.hasScanMobileClaim = Security.user.token.Claims.includes('69171055') // license.js: scanMobileNo = '69171055'
    this.hasPreRegistrationClaim = Security.user.token.Claims.includes(License.preRegistrationNo)
    this.hasWheelLoaderClaim = Security.user.token.Claims.includes('69171010') // license.js: wheelLoaderNo = '69171010'

    if (this.isAdmin()) {
      const res = await Admin.loadCorporations()
      if (!res.failed) {
        this.corporations = res.data.map(item => {
          return {
            text: item.Name,
            value: item.Id
          }
        })
      }
    }

    if (this.$route.params.id) {
      this.id = this.$route.params.id
      const res = await Admin.loadFacility(this.id)
      if (!res.failed) {
        this.form.no = res.data.No
        this.form.description = res.data.Description
        this.form.corporation = res.data.CorporationId
        this.form.active = res.data.DeletedDate == null
        this.details = res.data.Details
        if (this.hasStorageMapClaim) {
          const storageMapDetail = this.details.find(o => o.Name === 'StorageMapImage')
          if (storageMapDetail !== undefined) {
            if (storageMapDetail?.Data3AsBase64 != null) {
              var o = 'data:image/jpeg;base64,' + storageMapDetail?.Data3AsBase64
              this.item.FileItems.push({ ImageData: o, NameOfFile: 'filename' })
            }
          }

          const newUp = this.details.find(o => o.Name === 'newRegUpBtn')
          const newDown = this.details.find(o => o.Name === 'newRegDownBtn')
          const reg = this.details.find(o => o.Name === 'newRegBtn')
          if (newDown !== undefined) {
            this.form.newRegDownBtn = newDown?.Value === 'true'
          } else {
            this.form.newRegDownBtn = false
          }
          if (newUp !== undefined) {
            this.form.newRegUpBtn = newUp?.Value === 'true'
          } else {
            this.form.newRegUpBtn = false
          }
          if (reg !== undefined) {
            this.form.newRegBtn = reg?.Value === 'true'
          } else {
            this.form.newRegBtn = true
          }
        }
        if (this.hasPreRegistrationClaim) {
          const preRegistrationGPSPositionDetail = this.details.find(o => o.Name === 'PreRegistration_GPSPosition')
          if (preRegistrationGPSPositionDetail !== undefined) {
            this.form.preRegistrationGPSPosition = preRegistrationGPSPositionDetail?.Value
          } else {
            this.form.preRegistrationGPSPosition = '56.2050473652695, 10.185711838787292'
          }
          const preRegistrationGPSAcceptedDistanceKmDetail = this.details.find(o => o.Name === 'PreRegistration_GPSAcceptedDistanceKm')
          if (preRegistrationGPSAcceptedDistanceKmDetail !== undefined) {
            this.form.preRegistrationGPSAcceptedDistanceKm = preRegistrationGPSAcceptedDistanceKmDetail?.Value
          } else {
            this.form.preRegistrationGPSAcceptedDistanceKm = 0.2
          }
        }
        if (this.hasScanMobileClaim) {
          const localPrinterDetail = this.details.find(o => o.Name === 'localPrinter')
          if (localPrinterDetail !== undefined) {
            this.form.localPrinter = localPrinterDetail?.Value === 'true'
          }
          const localZplPrinterDetail = this.details.find(o => o.Name === 'localZplPrinter')
          if (localZplPrinterDetail !== undefined) {
            this.form.localZplPrinter = localZplPrinterDetail?.Value === 'true'
          }
          const printTitleDetail = this.details.find(o => o.Name === 'printTitle')
          if (printTitleDetail !== undefined) {
            this.form.printTitle = printTitleDetail?.Value
          }
        }
        if (this.hasWheelLoaderClaim) {
          const localPrinterDetailWl = this.details.find(o => o.Name === 'localPrinterWl')
          if (localPrinterDetailWl !== undefined) {
            this.form.localPrinterWl = localPrinterDetailWl?.Value === 'true'
          }
          const localZplPrinterDetailWl = this.details.find(o => o.Name === 'localZplPrinterWl')
          if (localZplPrinterDetailWl !== undefined) {
            this.form.localZplPrinterWl = localZplPrinterDetailWl?.Value === 'true'
          }
          const printTitleDetailWl = this.details.find(o => o.Name === 'printTitleWl')
          if (printTitleDetailWl !== undefined) {
            this.form.printTitleWl = printTitleDetailWl?.Value
          }
        }
      }
    }

    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>

<style scoped>
.image_container {
  position: relative;
  display: inline-block;
  text-align: center;
}
.image_container img {
  max-width: 100%;
}
.image_container .after {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
